module.exports = __webpack_public_path__ + "static/media/400065_01.56388a5f.png";